import { createTheme } from "@mui/material/styles";

export const makeTheme = (mode = "light") =>
  createTheme({
    palette: {
      mode,
      primary: { main: mode === "light" ? "#9e3f13" : "#f2a46f", contrastText: "#fff" },
      secondary: { main: mode === "light" ? "#7b2e3d" : "#ffb1bf" },
      background: {
        default: mode === "light" ? "#fffaf6" : "#17120f",
        paper: mode === "light" ? "#ffffff" : "#211a17"
      },
      text: {
        primary: mode === "light" ? "#281b16" : "#f8eee9",
        secondary: mode === "light" ? "#66544c" : "#d8c6bd"
      },
      divider: mode === "light" ? "#ead6cc" : "#4c3e38"
    },
    typography: {
      fontFamily: '"DM Sans", system-ui, sans-serif',
      h1: { fontFamily: '"Libre Baskerville", serif', fontWeight: 700 },
      h2: { fontFamily: '"Libre Baskerville", serif', fontWeight: 700 },
      h3: { fontFamily: '"Libre Baskerville", serif', fontWeight: 700 },
      h4: { fontFamily: '"Libre Baskerville", serif', fontWeight: 700 },
      button: { textTransform: "none", fontWeight: 700, letterSpacing: 0 }
    },
    shape: { borderRadius: 16 },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: { root: { borderRadius: 999, paddingInline: 22, minHeight: 44 } }
      },
      MuiCard: {
        styleOverrides: {
          root: {
            border: mode === "light" ? "1px solid #f0dfd7" : "1px solid #443731",
            boxShadow: mode === "light" ? "0 16px 50px rgba(76, 34, 17, .08)" : "0 16px 50px rgba(0,0,0,.2)"
          }
        }
      }
    }
  });
